module.exports = function() {
  return new Worker(__webpack_public_path__ + "c49ba0f18f41b8faf64d.worker.js");
};